export default __webpack_public_path__ + "static/media/nextauth.33ffabfe.png";